import { SxProps } from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import {
  REQUESTED_REHAB_SERVICE,
  REQUESTED_REHAB_SERVICE_TYPE,
} from "core/consts";
import { ValueOf } from "core/types";
import RadioGroupV2, { RadioOptionV2 } from "ds_legacy/components/RadioGroupV2";
import { RADIO_WHITE_BACKGROUND } from "ds_legacy/materials/colors";
import { sizing } from "ds_legacy/materials/metrics";
import { Section } from "dsl/ecosystems/PatientForms/components";
import { useTranslations } from "translations";

export const SectionOne = () => {
  const translations = useTranslations();

  const subFormOptions: RadioOptionV2<
    ValueOf<typeof REQUESTED_REHAB_SERVICE_TYPE>
  >[] = [
    {
      label: translations.patientForms.drvGeneralForm.sectionOne.outpatient,
      value: REQUESTED_REHAB_SERVICE_TYPE.OUTPATIENT,
    },
    {
      label: translations.patientForms.drvGeneralForm.sectionOne.inpatient,
      value: REQUESTED_REHAB_SERVICE_TYPE.INPATIENT,
    },
  ];

  const options: RadioOptionV2<ValueOf<typeof REQUESTED_REHAB_SERVICE>>[] = [
    {
      label:
        translations.patientForms.drvGeneralForm.sectionOne.rehabForInsured,
      subForm: (
        <RadioGroupV2
          elementName="requested_rehab_service_type_insured"
          flatModel
          formControlLabelSx={{
            marginLeft: sizing(2),
            paddingBottom: sizing(0.5),
          }}
          formLabelSx={visuallyHidden as SxProps}
          label={
            translations.patientForms.medicalForm.sectionSix.taxiOptionLabel
          }
          options={subFormOptions}
        />
      ),
      value: REQUESTED_REHAB_SERVICE.INSURED,
    },
    {
      label:
        translations.patientForms.drvGeneralForm.sectionOne.oncologicalRehab,
      subForm: (
        <RadioGroupV2
          elementName="requested_rehab_service_type_relatives"
          flatModel
          formControlLabelSx={{
            marginLeft: sizing(2),
            paddingBottom: sizing(0.5),
          }}
          formLabelSx={visuallyHidden as SxProps}
          label={
            translations.patientForms.medicalForm.sectionSix.taxiOptionLabel
          }
          options={subFormOptions}
        />
      ),
      value: REQUESTED_REHAB_SERVICE.RELATIVES,
    },
  ];

  return (
    <Section title={translations.patientForms.drvGeneralForm.sectionOne.title}>
      <RadioGroupV2
        elementName="requested_rehab_service"
        formControlLabelSx={{ marginLeft: 0, paddingBottom: sizing(0.5) }}
        formLabelSx={visuallyHidden as SxProps}
        label={translations.patientForms.drvGeneralForm.sectionOne.title}
        options={options}
        radioSx={RADIO_WHITE_BACKGROUND}
        sideMutation={(value, mutate) => {
          if (value === REQUESTED_REHAB_SERVICE.INSURED) {
            mutate(null, "requested_rehab_service_type_relatives");
          } else {
            mutate(null, "requested_rehab_service_type_insured");
          }
        }}
      />
    </Section>
  );
};
